// extracted by mini-css-extract-plugin
export default {"flexContainer":"contact-page_flexContainer__l2ohv","getInTouch":"contact-page_getInTouch__JXyP7","anchor":"contact-page_anchor__9ZCKJ"};